// external
import { writable } from 'svelte/store';
// libs
import { Api, getApiHost } from '../../../utils/index.js';
import { HttpMethod } from '../../../utils/index.js';
import Reporter from '../Reporter.js';
const _window = window
    ? window
    : {
        location: { href: '' }
    };
let state = {
    url: '',
    type: 'ajax',
    method: HttpMethod.POST,
    omitLogs: false
};
const store = writable(state);
const reporter = new Reporter(state);
const init = (config, omitLogs = false) => {
    const envMap = {
        dev: `${getApiHost()}${Api.POL_TRACKING}/v1/events`,
        qa: `${getApiHost()}${Api.POL_TRACKING}/v1/events`,
        staging: `${getApiHost()}${Api.POL_TRACKING}/v1/events`,
        prod: `${getApiHost()}${Api.POL_TRACKING}/v1/events`,
        'live.polaris.me': `${getApiHost()}${Api.POL_TRACKING}/v1/events`
    };
    // checks if the url contains dev, qa, staging, or prod
    const environment = Object.keys(envMap).find((key) => _window.location.href.includes(key)) || 'prod';
    // TODO: this needs to be based on the build
    // const url = envMap.dev;
    const url = _window.location.href.includes('localhost')
        ? envMap.dev
        : envMap[environment];
    state = {
        ...state,
        ...config,
        url,
        omitLogs: omitLogs
    };
    store.set(state);
    if (!config.baseParams ||
        (config.baseParams && config.baseParams.defaultShown === undefined)) {
        console.warn(`MISSING: boolean value for telemetry 'defaultShown' in parent app... Assuming true. PLEASE BE SURE TO INCLUDE THIS VALUE`);
    }
    reporter.updateConfig(state);
};
const updateReporter = (updatedConfig) => {
    state = {
        ...state,
        ...updatedConfig
    };
    store.set(state);
    reporter.updateConfig(state);
};
const sendReport = async (event) => {
    try {
        if (window.location.href.includes('localhost') && !state.omitLogs) {
            console.log(`logged sending report: `, {
                ...reporter.config.baseParams,
                ...event
            });
            return;
        }
        if (window.location.href.includes('localhost')) {
            return;
        }
        await reporter.sendReport(event);
    }
    catch (err) {
        console.warn(`WARNING: failed to send report, err = ${JSON.stringify(err)}`);
    }
};
const getBaseParams = () => {
    return reporter.config.baseParams;
};
export default {
    subscribe: store.subscribe,
    set: store.set,
    updateReporter: updateReporter,
    init,
    sendReport,
    getBaseParams
};
